import { Form } from "react-bootstrap";
import classes from "./form_control.module.css";

export default function FormControl({id, size, type, main_text, sub_text, indeterminate, theme, rsvp, no_margin, label_styles = {}, is_round, ...props}) {
    let label;
    if(main_text || sub_text) label = <div className={`d-flex flex-column align-items-start ${props.disabled ? "" : "pointer"}`} style={label_styles}>
            {main_text && <div className={`text-${size}-medium ${rsvp ? `${classes["rsvp-text"]} ${classes[rsvp]}` : ""}`}>{main_text}</div>}
            {sub_text && <div className={`text-${size}-regular ${rsvp ? `${classes["rsvp-text"]} ${classes[rsvp]}` : ""}`}>{sub_text}</div>}
        </div>

    props.className = [props.className, "d-flex", (size === "sm" ? "gap-2" : "gap-3"), (rsvp ? classes["rsvp-input"] : "")].filter(Boolean).join(" ");

    return <div className={[classes["form-control"], classes[size], classes[type], (indeterminate ? classes.indeterminate : ""), (theme ? classes[theme] : ""), (sub_text ? "" : classes["no-sub-text"]), (no_margin ? classes["no-margin"] : ""), (is_round ? classes["round"] : "")].filter(Boolean).join(" ")}>
        <Form.Check
            id={id}
            label={label}
            type={type}
            {...props}
        />
    </div>
}